import {
  ReactElement,
  ReactNode,
  MouseEventHandler,
  forwardRef,
  Ref,
} from 'react';

interface ButtonProps {
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  ref?: Ref<HTMLButtonElement>;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, onClick, className }, ref): ReactElement => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        className={`text-xl ${className && className} `}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
